import axios from "axios";

export const axiosES = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  maxBodyLength: Infinity,
  headers: {
    "Content-Type": "application/json",
  },
});
